import { Component } from '@angular/core';
import { convertToISO } from 'app/core/shared/helper/date.helper';
import { isFormChange } from 'app/core/shared/helper/equipment-registration.helper';
import { module } from 'app/modules/equipment-registration/equipment-registration.module';
import { XmasTree } from 'app/modules/equipment-registration/model/xmasTree.model';
import { EquipRegistrationServices } from 'app/modules/equipment-registration/services/equipment-registration.service';

@Component({
  selector: 'app-xmas-tree',
  templateUrl: './xmas-tree.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./xmas-tree.component.scss']
})
export class XmasTreeComponent {
  public equipmentRegistration$ = this.equipmentServices.equipmentRegistration$
  public isReplace: boolean = false;
  public disabledToggle: boolean = false;
  public xmasTreeForm: XmasTree = new XmasTree()
  public tempXmasTreeForm: XmasTree = new XmasTree()

  constructor(
    private equipmentServices: EquipRegistrationServices
  ) { }

  ngOnInit() {
    this.initializeXmasTreeForm()

    this.equipmentRegistration$.subscribe(wellEquipment => {
      if (wellEquipment?.xmasTree) {
        this.xmasTreeForm = new XmasTree(wellEquipment?.xmasTree);
      } else {
        this.initializeXmasTreeForm()
      }

      this.handleFormValue(wellEquipment)

      this.isReplace = !wellEquipment?.xmasTree;
      this.disabledToggle = !wellEquipment?.xmasTree;
      this.tempXmasTreeForm = new XmasTree(this.xmasTreeForm)
    })
  }

  private initializeXmasTreeForm(): void {
    this.xmasTreeForm.reset()
  }

  private handleFormValue(wellEquipment) {
    if (!this.xmasTreeForm.wellStringId) {
      this.xmasTreeForm.wellStringId = wellEquipment?.wellStringId
    }
  }

  treecapConnChange($event) {
    let selectedValue = $event.value
    if (selectedValue === 'OTHERS') return

    this.xmasTreeForm.treecapConnRemarks = ''
  }

  disabledSave(): boolean {
    return !this.xmasTreeForm.wellStringId || isFormChange(this.xmasTreeForm, this.tempXmasTreeForm)
  }

  save() {
    const operation = this.isReplace ?
      this.equipmentServices.addSceXmasTree(this.xmasTreeForm) :
      this.equipmentServices.updateSceXmasTree(this.xmasTreeForm);

    operation.subscribe((res) => {
      if (res) {
        this.equipmentServices.getEquipmentRegistration(this.xmasTreeForm.wellStringId).subscribe();
      }
    });
  }

formatDecimal(value: number | null | undefined): void {
  if (value === null || value === undefined || isNaN(value)) {
    this.xmasTreeForm.treeCapConnSize = null;
    return;
  }

  this.xmasTreeForm.treeCapConnSize = Number(value.toFixed(2));
}
}
